import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useFileDownloader from '../../useFileDownloader';

const useDownloadDriverTemplate = () => {
    const request = useFileDownloader();
    const [loading, setLoading] = useState(false);

    const onDownloadDriverTemplateError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while downloading driver template'
        );
    };

    const onDownloadDriverTemplateSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        toast.success("Driver template started downloading");
    };

    const downloadDriverTemplate = () => {
        const url: HttpConfig = {
            url: `api/v1/dispatchers/get-excel-sample`,
            method: 'get',
        };

        request(url, onDownloadDriverTemplateSuccess, setLoading, onDownloadDriverTemplateError, 'DriverTemplate.xlsx');
    };

    return { downloadDriverTemplate, loading };
};

export default useDownloadDriverTemplate;

